import ModalPortal from '@/components/ModalPortal/ModalPortal';
import { UseFormState } from '@/hooks/useForm/interfaces';
import useFrcCaptcha from '@/hooks/useFrcCaptcha/useFrcCaptcha';
import useSubmitContactForm from '@/hooks/useSubmitContactForm/useSubmitContactForm';
import CourseRequestForm from '../CourseRequestForm/CourseRequestForm';
import ModalContent from '../Modal/ModalContent';
import { createCourseRequestSubmitFormData } from './helpers';

type CourseRequestFormModalProps = {
  categoryTitle: string;
  courseLink: string;
  formApiTarget: string;
  id: string;
  mailTemplateId: string;
  recipientId: string;
  title: string;
};

const CourseDetailRequestFormModal = ({
  categoryTitle,
  courseLink,
  formApiTarget,
  id,
  mailTemplateId,
  recipientId,
  title,
}: CourseRequestFormModalProps) => {
  const formName = `Individuelle Anfrage - ${categoryTitle} - ${title}`;

  const { getSolution, FrcCaptchaComponent } = useFrcCaptcha();

  const {
    submitContactForm: submitRequestForm,
    submitButtonStatus: submitRequestFormStatus,
  } = useSubmitContactForm({
    formName,
    recipientId,
    mailTemplateId,
    formApiTarget,
    doubleOptInActive: false,
    getCaptchaSolution: getSolution,
  });

  const handleSubmitRequestForm = (data: UseFormState) => {
    submitRequestForm(
      createCourseRequestSubmitFormData({
        ...data,
        title,
        courseLink,
        categoryTitle,
      })
    );
  };

  return (
    <ModalPortal id={id}>
      <ModalContent>
        <CourseRequestForm
          onSubmit={handleSubmitRequestForm}
          submitButtonStatus={submitRequestFormStatus}
          formName={formName}
        />
        <FrcCaptchaComponent />
      </ModalContent>
    </ModalPortal>
  );
};

export default CourseDetailRequestFormModal;
